import { render, staticRenderFns } from "./EditDateDocumentDialog.vue?vue&type=template&id=5638b31e&"
import script from "./EditDateDocumentDialog.vue?vue&type=script&lang=js&"
export * from "./EditDateDocumentDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports